import { z } from 'zod';

import { calculationDataSchema, lineSchema, paymentTermSchema } from '../common/schemas';

export const invoiceTemplateTypeSchema = z.enum(['Manual', 'Recurring']);
export const invoiceTemplateIntervalSchema = z.enum(['Weekly', 'Monthly', 'Quarterly']);
export const invoiceTemplateIntervalStatusSchema = z.enum(['Live', 'Paused']);

const baseInvoiceTemplateSchema = z.object({
  id: z.number(),
  numberingSeriesId: z.number().nullable(),
  brandId: z.number().nullable(),
  clientId: z.number().nullable(),
  contactId: z.number().nullable(),
  conditionId: z.number().nullable(),
  customConditionId: z.number().nullable(),
  customAgreementId: z.number().nullable(),
  title: z.string(),
  paymentTerm: paymentTermSchema.nullable(),
  paymentTermEndOfMonth: z.boolean(),
  description: z.string().nullable(),
  clientReference: z.string().nullable(),
  specialConditions: z.string().nullable(),
  lines: lineSchema.array(),
  calculationData: calculationDataSchema,
  totalInvoices: z.number(),
  totalAdvantage: z.number(),
});

export const manualInvoiceTemplateSchema = z.object({
  ...baseInvoiceTemplateSchema.shape,
  type: invoiceTemplateTypeSchema.extract(['Manual']),
  interval: z.null(),
  intervalStatus: z.null(),
  nextInvoiceAt: z.null(),
});

export const recurringInvoiceTemplateSchema = z.object({
  ...baseInvoiceTemplateSchema.shape,
  type: invoiceTemplateTypeSchema.extract(['Recurring']),
  interval: invoiceTemplateIntervalSchema,
  intervalStatus: invoiceTemplateIntervalStatusSchema,
  nextInvoiceAt: z.iso.datetime({ offset: true }),
});

export const invoiceTemplateSchema = z.discriminatedUnion('interval', [manualInvoiceTemplateSchema, recurringInvoiceTemplateSchema]);

export const invoiceTemplateFiltersSchema = z.object({
  clientIds: z.array(z.number()),
  brandIds: z.array(z.number()),
  types: z.array(invoiceTemplateTypeSchema),
});
